import Vue from 'vue'

import { MdBadge, MdButton} from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

Vue.use(MdBadge)
Vue.use(MdButton)